import React, { useEffect, useState } from 'react';
import { Card, Col, Button, ButtonToolbar, Table, CardBody, } from 'reactstrap';
import history from '../../../history';
import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake.js';
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const InvoiceTemplate = () => {

  const [fechaVencimiento, setFechaVencimiento] = useState('');
  const [fechaEmision, setFechaEmision] = useState('');
  const [third, setThirtd] = useState([]);

  const invoceData = history.location.state.dataInvoice.facturas;
  const urlLogo = 'https://i.postimg.cc/WpG6Rg5q/logo-SAC-App-New.png'

  useEffect(() => {
    console.log(history.location.state);
    getThird(history.location.state.dataInvoice.id_tercero);
    getDate(history.location.state.dataInvoice.fecha_emision);
  }, []);

  const getThird = (id) => {


    fetch(process.env.REACT_APP_PUBLIC_URL + 'tercero/ver/' + id, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },

    }).then(response => {
      return response.json();
    })
      .then(data => {
        console.log(data);
        if (data.existe) {
          setThirtd(data.contenido[0]);
        } else {
          alert(data.contenido);
        }
      }).catch((error) => {
        console.error('Error:', error);
      });
  }

  const getBase64ImageFromURL = (url) => {

    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");

      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        var dataURL = canvas.toDataURL("image/png");

        resolve(dataURL);
      };

      img.onerror = error => {
        reject(error);
      };

      img.src = url;
    });
  }


  const generateDocDef = async () => {

    let itemBody = [
      [
        { text: "#", style: "tableHeader" },
        { text: "Servicio", style: "tableHeader" },
        { text: "Costo", style: "tableHeader", alignment: "center" },
      ],
    ];
    let itemArr = ["", "", ""];
    if (invoceData.servicios.servicios.length === 0) itemBody.push(itemArr);
    for (let index = 0; index < invoceData.servicios.servicios.length; index++) {
      const element = invoceData.servicios.servicios[index];
      itemBody.push([
        index + 1,
        element.servicios,
        { text: element.costo, alignment: "center" },
      ]);
    }

    const docDefinition = {
      pageSize: 'LETTER',
      pageOrientation: 'portrait',
      info: {
        title: "Factura No#" + invoceData.num_fac_pac,
        author: "Medical Teams",
        subject: "Factura No#" + invoceData.num_fac_pac,
        keywords: "Factura No#" + invoceData.num_fac_pac,
      },
      footer: function (currentPage, pageCount, pageSize) {
        return [
          {
            canvas: [
              {
                type: "rect",
                x: 0,
                y: 0,
                w: pageSize.width,
                h: 5,
                color: "#0069D9",
              },
            ],
          },
          {
            text: "Page " + currentPage.toString() + " of " + pageCount + "   ",
            alignment: "right",
            margin: [0, 10, 40, 0],
          },
        ];
      },
      header: function (currentPage, pageCount, pageSize) {
        return [
          {
            canvas: [
              {
                type: "rect",
                x: 0,
                y: 10,
                w: pageSize.width,
                h: 15,
                color: "#0069D9",
              },
            ],
          },
        ];
      },
      content: [
        {
          columns: [
            {
              width: "auto",
              columns: [
                {
                  image: await getBase64ImageFromURL(urlLogo),
                  width: 100,
                  height: 50,
                },
              ],
            },
            {
              width: "*",
              text: [
                {
                  text: "Factura No: #" + invoceData.num_fac_pac,
                  fontSize: 15,
                  bold: true,
                  alignment: "right",
                  lineHeight: 1.2,
                },
                "\n",
                {
                  text: "Factura Fecha: " + fechaEmision,
                  alignment: "right",
                },
                "\n",
                {
                  text: "Fecha Vencimiento: " + fechaVencimiento,
                  alignment: "right",
                },
              ],
            },
          ],
        },
        {
          style: "tableExample",
          table: {
            headerRows: 1,
            widths: ["auto", "*"],
            dontBreakRows: true,
            // keepWithHeaderRows: 1,
            body: [
              [
                { text: "Bill From", style: "tableHeader" },
                { text: "Bill For", style: "tableHeader" },
              ],
              [third.nombre + '\n' + third.nit, invoceData.nombres + ' ' + invoceData.apellido1],
            ],
          },
          layout: {
            fillColor: function (rowIndex, node, columnIndex) {
              return rowIndex === 0 ? "#CCCCCC" : null;
            },
          },
        },
        {
          style: "tableExample",
          table: {
            headerRows: 1,
            widths: ["auto", "*", 50],
            // keepWithHeaderRows: 1,
            body: itemBody,
          },
          layout: "lightHorizontalLines",
        },
        {
          columns: [
            {
              width: "*",
              text: [
                {
                  text: "",
                  fontSize: 10,
                },
              ],
            },
            {
              width: "auto",
              columns: [
                {
                  width: "*",
                  text: [
                    {
                      text: "Subtotal",
                      alignment: "right",
                      lineHeight: 1.2,
                    },
                    "\n",
                    {
                      text: "Discounts",
                      alignment: "right",
                      lineHeight: 1.2,
                    },
                    "\n",
                    {
                      text: "Shipping",
                      alignment: "right",
                      lineHeight: 1.2,
                    },
                    "\n",
                    {
                      canvas: [
                        {
                          type: "line",
                          x1: 0,
                          y1: 5,
                          x2: 250,
                          y2: 5,
                          lineWidth: 3,
                        },
                      ],
                    },
                    {
                      text: "Total",
                      fontSize: 12,
                      bold: true,
                      alignment: "right",
                    },
                  ],
                },
                {
                  width: "auto",
                  text: [
                    {
                      text: "0",
                      alignment: "right",
                      lineHeight: 1.2,
                    },
                    "\n",
                    {
                      text: "0",
                      alignment: "right",
                      lineHeight: 1.2,
                    },
                    "\n",
                    {
                      text: "0",
                      alignment: "right",
                      lineHeight: 1.2,
                    },
                    "\n",
                    {
                      text: invoceData.total,
                      fontSize: 12,
                      bold: true,
                      alignment: "right",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 0, 0, 10],
        },
        subheader: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 5],
        },
        tableExample: {
          margin: [0, 5, 0, 15],
        },
        tableHeader: {
          bold: true,
          fontSize: 13,
          color: "black",
        },
      },
      defaultStyle: {
        columnGap: 15,
      },
    };

    pdfMake.createPdf(docDefinition).open();
  };

  const getDate = () => {

    setFechaEmision(moment(history.location.state.dataInvoice.fecha_emision).format('ll'));
    setFechaVencimiento(moment(history.location.state.dataInvoice.vencimiento).format('ll'))

  }

  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody className="invoice">
          <div className="invoice__head">
            <div className="invoice__head-left">
              <div className="invoice__logo" />
              <p>{third.nombre} </p>
              <p>{third.nit}</p>
              <p>{third.grupocliente}</p>
              <p>{third.direccion} </p>
              <p dir="ltr">{third.telefono}</p>
            </div>
            <div className="invoice__head-right">
              <h4>Factura # {invoceData.num_fac_pac}</h4>
              <p className="invoice__date">{fechaEmision}</p>
              <p>{invoceData.nombres} {invoceData.apellido1} {invoceData.apellido2}</p>
              <p>{invoceData.tipo_pago} </p>
              <p>{invoceData.medio_pago.medio[0].medio} </p>

            </div>
          </div>
          <Table className="table--bordered" responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Servicio</th>
                <th>Costo</th>
              </tr>
            </thead>
            <tbody>
              {invoceData.servicios.servicios.map((item, index) => (
                <tr key={item.id_servicio}>
                  <td>{index + 1}</td>
                  <td>{item.servicios}</td>
                  <td>{item.costo}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          <div className="invoice__total">
            <p>Sub - Total amount: $126.00</p>
            <p>VAT: $20.00</p>
            <p className="invoice__grand-total"> Total: ${invoceData.total}</p>
            <ButtonToolbar className="invoice__toolbar">
              <Button color="primary">Proceed to payment</Button>
              <Button onClick={() => {
                generateDocDef();
              }}>Print</Button>
            </ButtonToolbar>
          </div>
        </CardBody>
      </Card>
    </Col>);
}

export default InvoiceTemplate;
